import React from "react";
import PageHeader from "../../../components/ui/page header/PageHeader";
import { useTranslation } from "react-i18next";
import ServicesSection from "./components/servicesSection/ServicesSection";

function ServicesPage() {
  const { t } = useTranslation("services");

  return<>
    <PageHeader
      topic={t("pageHeader.topic")}
      topicSentence={t("pageHeader.topicSentence")}
    />
    <ServicesSection/>
  </>;
}

export default ServicesPage;
